import {useEffect, useMemo} from 'react'

import useEventSelector from './useEventSelector'
import type {EqualityFn} from './useEventSelector'

export default function useIntersectionSelector<T>(
  ref: {
    current: HTMLElement | null | undefined
  },
  selector: (arg0: IntersectionObserverEntry | null | undefined) => T,
  options?: IntersectionObserverInit,
  equalityFn?: EqualityFn<T>,
): T {
  const [value, callback] = useEventSelector(selector, equalityFn)

  /* eslint-disable react-hooks/exhaustive-deps */
  const observer = useMemo(
    () =>
      new IntersectionObserver(
        entries => entries.filter(entry => entry.target === ref.current).forEach(callback),
        options,
      ),
    [callback, ...Object.values(options ?? {})],
  )

  /* eslint-enable */
  useEffect(() => {
    const {current} = ref

    if (current != null) {
      observer.observe(current)
    }

    return () => observer.disconnect()
  }, [observer, ref])
  return value
}
